export default {
  // Bienvenida
  "notify.welcome.title": "¡Bienvenido a VendeYa! 🎉",
  "notify.welcome.message":
    "Tu cuenta fue creada correctamente. Ya puedes comenzar a explorar productos, guardar favoritos y realizar compras.",
  "notify.welcome.verify":
    "Te enviamos un correo para confirmar tu dirección de email. Revisa tu bandeja de entrada.",

  // Solicitud de vendedor
  "notify.seller.submitted.title": "¡Solicitud enviada! 🎉",
  "notify.seller.submitted.message":
    "Recibimos tu solicitud para convertirte en vendedor de VendeYa. Nuestro equipo revisará la información proporcionada y te notificará cuando tu solicitud sea aprobada.",
  "notify.seller.submitted.state": "Solicitud pendiente de revisión",
  "notify.seller.submitted.note":
    "Puedes seguir utilizando VendeYa normalmente mientras esperamos la revisión.",

  "notify.seller.incomplete.title": "No puedes enviar la solicitud todavía",
  "notify.seller.incomplete.message":
    "Hay información obligatoria que debes completar antes de enviar tu solicitud para vendedor.",
  "notify.seller.incomplete.cta": "Completar solicitud",

  "notify.seller.verification.title": "Falta completar tu verificación",
  "notify.seller.verification.message":
    "Para solicitar la aprobación como vendedor debes completar la documentación requerida.",

  "notify.seller.review.title": "Solicitud en revisión",
  "notify.seller.review.message":
    "Tu solicitud está siendo revisada por el equipo de VendeYa.",

  "notify.seller.approved.title": "🎉 ¡Felicidades! Ya eres vendedor de VendeYa",
  "notify.seller.approved.message":
    "Tu solicitud fue aprobada. Ahora puedes comenzar a publicar tus artículos y vender en VendeYa.",
  "notify.seller.approved.cta": "Publicar mi primer artículo",

  "notify.seller.rejected.title": "Tu solicitud de vendedor no fue aprobada",
  "notify.seller.rejected.message": "Por el momento no podemos aprobar tu solicitud.",
  "notify.seller.rejected.reason": "Motivo del rechazo:",
  "notify.seller.rejected.cta": "Corregir solicitud",

  "notify.seller.suspended.title": "Tu cuenta de vendedor fue suspendida",
  "notify.seller.suspended.message":
    "Tu capacidad para publicar y vender temporalmente ha sido suspendida.",
  "notify.seller.suspended.reason": "Motivo:",
  "notify.seller.suspended.cta": "Ver detalles",

  "notify.seller.notSeller.title": "Primero debes convertirte en vendedor",
  "notify.seller.notSeller.message":
    "Para publicar artículos necesitas tener una cuenta de vendedor aprobada.",
  "notify.seller.notSeller.cta": "Registrarme como vendedor",

  "notify.seller.pendingPublish.title": "Tu cuenta todavía está en revisión",
  "notify.seller.pendingPublish.message":
    "Ya solicitaste convertirte en vendedor, pero tu solicitud todavía está siendo revisada. Podrás publicar cuando sea aprobada.",
  "notify.seller.pendingPublish.cta": "Ver estado de solicitud",

  // Publicación y tickets
  "notify.publish.noTicket.title": "⚠️ Falta el ticket de verificación",
  "notify.publish.noTicket.message":
    "Este artículo no puede publicarse todavía porque debe tener un ticket de verificación generado por VendeYa.",
  "notify.publish.noTicket.explain":
    "La fotografía de portada puede utilizarse como imagen principal del producto, pero las fotografías adicionales de la galería deben incluir el ticket correspondiente.",
  "notify.publish.noTicket.cta": "Agregar fotografías",

  "notify.publish.galleryNoTicket.title": "Esta fotografía no cumple con los requisitos",
  "notify.publish.galleryNoTicket.message":
    "Todas las fotografías de la galería deben mostrar el mismo ticket de verificación asignado a este artículo.",

  "notify.publish.wrongTicket.title": "El ticket no coincide",
  "notify.publish.wrongTicket.message":
    "Esta fotografía contiene un ticket diferente al asignado a este artículo.",

  "notify.publish.ticketRequired": "Ticket requerido:",
  "notify.publish.correctTicket": "Ticket correcto:",

  "notify.publish.cover.label": "Imagen de portada",
  "notify.publish.cover.description":
    "Esta imagen puede utilizarse como portada promocional del artículo.",

  "notify.publish.ticketGenerated.title": "¡Ticket generado correctamente! 🎟️",
  "notify.publish.ticketGenerated.message": "Este ticket identifica tu artículo dentro de VendeYa.",
  "notify.publish.ticketGenerated.cta": "Continuar con las fotografías",

  "notify.publish.published.title": "🎉 ¡Artículo publicado!",
  "notify.publish.published.message":
    "Tu artículo ya está disponible en VendeYa y puede ser encontrado por compradores.",
  "notify.publish.published.ctaView": "Ver publicación",
  "notify.publish.published.ctaOther": "Publicar otro artículo",

  "notify.publish.draft.title": "Borrador guardado",
  "notify.publish.draft.message":
    "Tu artículo fue guardado como borrador. Puedes continuar editándolo cuando quieras.",

  // Imágenes
  "notify.image.uploadError.title": "No pudimos subir la imagen",
  "notify.image.uploadError.message":
    "La imagen no pudo cargarse correctamente. Verifica tu conexión a internet e inténtalo nuevamente.",
  "notify.image.format.title": "Formato no compatible",
  "notify.image.format.message":
    "Este tipo de archivo no está permitido. Utiliza JPG, JPEG, PNG o WEBP.",
  "notify.image.tooBig.title": "La imagen es demasiado grande",
  "notify.image.tooBig.message":
    "Esta imagen supera el tamaño máximo permitido. Selecciona una imagen más pequeña.",

  // Perfil
  "notify.profile.updated.title": "¡Perfil actualizado!",
  "notify.profile.updated.message": "Los cambios de tu perfil fueron guardados correctamente.",
  "notify.profile.avatar.title": "¡Foto de perfil actualizada!",
  "notify.profile.avatar.message": "Tu nueva foto de perfil ya está visible en VendeYa.",
  "notify.profile.cover.title": "¡Portada actualizada!",
  "notify.profile.cover.message": "Tu nueva foto de portada ya está visible en tu perfil.",

  // Contraseña
  "notify.password.sent.title": "Revisa tu correo",
  "notify.password.sent.message": "Te enviamos un enlace seguro para cambiar tu contraseña.",
  "notify.password.updated.title": "🔐 Contraseña actualizada",
  "notify.password.updated.message": "Tu contraseña fue cambiada correctamente.",

  // Membresía
  "notify.membership.active.title": "🎉 ¡Ahora estás verificado!",
  "notify.membership.active.message":
    "Tu membresía de VendeYa Verificado está activa. Tu perfil ahora mostrará la insignia azul de verificación.",
  "notify.membership.active.badge": "✓ Verificado",
  "notify.membership.expiring.title": "Tu membresía está próxima a vencer",
  "notify.membership.expiring.message":
    "Tu membresía de VendeYa Verificado vence el {{date}}. Renueva para mantener tu insignia de verificación.",
  "notify.membership.expiring.cta": "Renovar membresía",
  "notify.membership.expired.title": "Tu membresía ha expirado",
  "notify.membership.expired.message":
    "Tu membresía de VendeYa Verificado ya no está activa y la insignia azul fue retirada.",
  "notify.membership.expired.cta": "Volver a verificarme",

  // Pedidos y pagos
  "notify.order.completed.title": "🎉 ¡Compra realizada correctamente!",
  "notify.order.completed.message": "Tu pago fue confirmado y tu pedido ha sido registrado.",
  "notify.order.completed.cta": "Ver mi pedido",
  "notify.order.paymentFailed.title": "No pudimos completar el pago",
  "notify.order.paymentFailed.message":
    "El pago no fue aprobado. No hemos confirmado este pedido.",
  "notify.order.paymentFailed.cta": "Intentar nuevamente",
  "notify.order.shipped.title": "📦 ¡Tu pedido está en camino!",
  "notify.order.shipped.message": "El vendedor ha enviado tu pedido.",
  "notify.order.delivered.title": "🎉 ¡Pedido entregado!",
  "notify.order.delivered.message": "Tu pedido fue marcado como entregado.",
  "notify.order.delivered.cta": "Ver pedido",

  // Favoritos y carrito
  "notify.favorite.added": "❤️ Agregado a favoritos",
  "notify.favorite.removed": "Eliminado de favoritos",
  "notify.cart.added.title": "🛒 Producto agregado al carrito",
  "notify.cart.added.message": "El artículo fue agregado correctamente.",

  // Seguridad
  "notify.security.title": "⚠️ Actividad de seguridad",
  "notify.security.message":
    "Detectamos una actividad inusual en tu cuenta. Si no reconoces esta actividad, revisa inmediatamente la seguridad de tu cuenta.",

  // Acciones administrativas
  "notify.admin.approved": "Vendedor aprobado correctamente.",
  "notify.admin.rejected": "Solicitud rechazada correctamente.",
  "notify.admin.suspended": "Vendedor suspendido correctamente.",
  "notify.admin.blocked": "Usuario bloqueado correctamente.",
  "notify.admin.restored": "Usuario reactivado correctamente.",
  "notify.admin.permissions": "Permisos actualizados correctamente.",

  // Centro de notificaciones
  "notifications.title": "Notificaciones",
  "notifications.subtitle": "Todas las novedades de tu cuenta y tus artículos.",
  "notifications.all": "Todas",
  "notifications.unread": "No leídas",
  "notifications.markAll": "Marcar todas como leídas",
  "notifications.empty": "No tenés notificaciones",
  "notifications.emptyDesc": "Cuando ocurra algo importante, te lo mostraremos aquí.",
};